import { render, staticRenderFns } from "./HolderForm.vue?vue&type=template&id=f2b527f8&scoped=true&"
import script from "./HolderForm.vue?vue&type=script&lang=ts&"
export * from "./HolderForm.vue?vue&type=script&lang=ts&"
import style0 from "./HolderForm.vue?vue&type=style&index=0&id=f2b527f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b527f8",
  null
  
)

export default component.exports